import { ObjectStat } from '../models/ObjectStat';
import { ObjectStatItem } from '../models/ObjectStatItem';

export class ObjectStatsMapper {
  mapGQLModel(data: any): ObjectStat[] {
    if (!data?.length) return [];

    const buffer: { [type: string]: { total: number; stats: ObjectStatItem[] } } = {};

    for (const stat of data) {
      if (!buffer[stat.type]) {
        buffer[stat.type] = { total: 0, stats: [] };
      }
      buffer[stat.type].total += stat.count;
      buffer[stat.type].stats.push(new ObjectStatItem(stat.type, stat.value, stat.count));
    }

    return Object.keys(buffer).map((type: string) => new ObjectStat(type, buffer[type].total, buffer[type].stats));
  }
}
